import { Phone, Mail, MessageCircle, Facebook, MapPin } from "lucide-react";

const items = [
  {
    icon: Phone,
    label: "Telefon",
    value: "0742 447 340",
    href: "tel:0742447340",
    testid: "contact-phone",
  },
  {
    icon: MessageCircle,
    label: "WhatsApp",
    value: "+40 754 539 886",
    href: "https://wa.me/40754539886",
    testid: "contact-whatsapp",
  },
  {
    icon: Mail,
    label: "Email",
    value: "global.transport.mangalia@gmail.com",
    href: "mailto:global.transport.mangalia@gmail.com",
    testid: "contact-email",
  },
  {
    icon: Facebook,
    label: "Facebook",
    value: "GlobalTransportMangalia",
    href: "https://www.facebook.com/GlobalTransportMangalia",
    testid: "contact-facebook",
  },
];

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-20 lg:py-28 bg-slate-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-amber-600 font-semibold text-sm uppercase tracking-widest">
              Contact
            </span>
            <h2
              data-testid="contact-title"
              className="mt-3 text-3xl lg:text-4xl font-bold text-white"
            >
              Suntem la un apel distanță.
            </h2>
            <p className="mt-5 text-slate-300 leading-relaxed max-w-md">
              Pentru rezervări sau întrebări, contactează-ne oricând. Răspundem
              în cel mai scurt timp posibil — telefonic, WhatsApp sau email.
            </p>

            <div className="mt-8 inline-flex items-center gap-3 bg-slate-900 text-white rounded-2xl px-5 py-4">
              <MapPin className="w-5 h-5 text-amber-400" />
              <div>
                <div className="text-xs uppercase tracking-widest text-amber-400">
                  Sediu
                </div>
                <div className="font-semibold">Mangalia, județul Constanța</div>
              </div>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            {items.map((it) => (
              <a
                key={it.label}
                href={it.href}
                target={it.href.startsWith("http") ? "_blank" : undefined}
                rel={it.href.startsWith("http") ? "noopener noreferrer" : undefined}
                data-testid={it.testid}
                className="group block bg-slate-950 hover:bg-amber-500 border border-slate-800 hover:border-amber-500 rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-11 h-11 rounded-xl bg-slate-900 group-hover:bg-slate-900 text-amber-400 flex items-center justify-center">
                  <it.icon className="w-5 h-5" strokeWidth={2.2} />
                </div>
                <div className="mt-4 text-xs uppercase tracking-wider text-slate-400 group-hover:text-white font-semibold">
                  {it.label}
                </div>
                <div className="mt-1 font-semibold text-white break-words">
                  {it.value}
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
